module.exports = __webpack_public_path__ + "img/rage.9c8a6f9d.png";